import cn from './zh'
import en from './en'
import { useUserStore } from '@/stores/user'

const langKey: 'cn' | 'en' = {
  cn,
  en
}

type Key = keyof typeof cn | keyof typeof en
const lang = (key: Key) => {
  const language = useUserStore().header.language.toLowerCase() || 'en'
  return langKey[language][key] || key
}

export default lang
